import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { CheckCircle, XCircle, Loader2, RefreshCw, AlertTriangle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SenderStatus = ({ getAuthHeaders }) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = () => {
    setLoading(true);
    axios.get(`${API}/admin/email/sender-status`, { headers: getAuthHeaders() })
      .then((r) => setStatus(r.data))
      .catch(() => setStatus({ error: 'Impossibile verificare il mittente' }))
      .finally(() => setLoading(false));
  };
  useEffect(check, []); // eslint-disable-line react-hooks/exhaustive-deps

  const recheck = (
    <Button variant="outline" size="sm" onClick={check} disabled={loading} data-testid="sender-recheck-btn">
      {loading ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <RefreshCw className="h-3.5 w-3.5 mr-1" />} Ricontrolla
    </Button>
  );

  if (!status) return <div className="mt-3"><Loader2 className="h-4 w-4 animate-spin" /></div>;

  if (status.verified) {
    return (
      <div className="mt-3 flex flex-wrap items-center gap-3 text-sm" data-testid="sender-status-ok">
        <span className="flex items-center gap-1.5 text-green-400"><CheckCircle className="h-4 w-4" /> Mittente verificato: <strong>{status.sender}</strong></span>
        {recheck}
      </div>
    );
  }

  if (status.limited_key) {
    return (
      <div className="mt-3 space-y-2 text-sm" data-testid="sender-status-active">
        <p className="flex items-center gap-1.5 text-green-400"><CheckCircle className="h-4 w-4" /> Invio email attivo da <strong>{status.sender}</strong></p>
        <p className="text-xs text-muted-foreground">Per vedere se un'email è arrivata: Storico Notifiche → "Aggiorna stato consegna".</p>
      </div>
    );
  }

  if (status.verified === false) {
    return (
      <div className="mt-3 rounded-lg border border-red-500/40 bg-red-500/10 p-4 space-y-2 text-sm" data-testid="sender-status-blocked">
        <p className="flex items-center gap-1.5 font-semibold text-red-400"><XCircle className="h-4 w-4" /> Le email sono bloccate: il mittente {status.sender} non è verificato su Brevo</p>
        <ol className="list-decimal ml-5 space-y-1 text-muted-foreground">
          <li>Accedi a <a href="https://app.brevo.com/senders/list" target="_blank" rel="noopener noreferrer" className="text-accent underline">Brevo → Mittenti</a></li>
          <li>Premi "Aggiungi mittente" e inserisci <strong className="text-foreground">{status.sender}</strong></li>
          <li>Apri la casella {status.sender} e conferma il codice/link ricevuto da Brevo</li>
          <li>Torna qui e premi "Ricontrolla"</li>
        </ol>
        {status.verified_senders?.length > 0 && (
          <p className="text-xs text-muted-foreground">Mittenti già verificati nel tuo account: {status.verified_senders.join(', ')}</p>
        )}
        {recheck}
      </div>
    );
  }

  return (
    <div className="mt-3 flex flex-wrap items-center gap-3 text-sm text-yellow-500" data-testid="sender-status-unknown">
      <AlertTriangle className="h-4 w-4" /> {status.error || 'Stato del mittente non disponibile'} {recheck}
    </div>
  );
};

export default SenderStatus;
